/* eslint-disable no-underscore-dangle */
// Libs
import { compose, createStore, combineReducers, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import thunk from "redux-thunk";

// Reducers
import Filters from "./components/dataflow/filters-module";
import TabsList from "./components/dataflow/tabs-list-module";
import Tabs from "./components/dataflow/tabs-module";
import Utils from "./components/dataflow/utils-module";
import Authentication from "./modules/authentication/dataflow/auth-module";
import Campaigns from "./modules/campaigns/dataflow/campaigns-module";
import Contacts from "./modules/contact/dataflow/contacts-module";
import MyActivity from "./modules/myActivity/dataflow/myActivity-module";
import SearchContactsRetention from "./modules/retention/dataflow/search-module";
import SearchContacts from "./modules/search/dataflow/search-module";
import Registration from "./modules/studentRegistration/dataflow/registration-module";
import Users from "./modules/users/dataflow/user-module";

const reducers = combineReducers({
  auth: Authentication,
  utils: Utils,
  filters: Filters,
  tabs: Tabs,
  tabsList: TabsList,
  searchContacts: SearchContacts,
  searchContactsRetention: SearchContactsRetention,
  contacts: Contacts,
  users: Users,
  campaigns: Campaigns,
  registration: Registration,
  myActivity: MyActivity,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "tabs", "tabsList", "filters"],
};
const persistedReducer = persistReducer(persistConfig, reducers);

const bundle = compose(applyMiddleware(thunk));
const createStoreWithMiddleware = bundle(createStore);
export const store = createStoreWithMiddleware(
  persistedReducer,
  {},
  window.__REDUXD_EVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f
);
export const persistor = persistStore(store);
